import { Button } from '../ui/button';
import { Ban, CreditCard } from 'lucide-react';

export function BatchActionsBar({ selected, onAction, onClear }) {
  return (
    <div className="flex items-center gap-3 bg-cyan-500/10 border border-cyan-500/20 rounded-xl p-3" data-testid="batch-actions">
      <span className="text-cyan-400 text-sm font-medium">{selected.size} selected</span>
      <Button size="sm" variant="outline" onClick={() => onAction('suspend')}
        className="border-amber-500/30 text-amber-400 text-xs" data-testid="batch-suspend">
        <Ban className="w-3 h-3 mr-1" /> Suspend
      </Button>
      <Button size="sm" variant="outline" onClick={() => onAction('unsuspend')}
        className="border-emerald-500/30 text-emerald-400 text-xs" data-testid="batch-unsuspend">
        Unsuspend
      </Button>
      <Button size="sm" variant="outline" onClick={() => onAction('credits')}
        className="border-cyan-500/30 text-cyan-400 text-xs" data-testid="batch-credits">
        <CreditCard className="w-3 h-3 mr-1" /> Add Credits
      </Button>
      <Button size="sm" variant="ghost" onClick={onClear}
        className="text-white/40 text-xs ml-auto">Clear</Button>
    </div>
  );
}
